import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppFloat.css";

const WhatsAppFloat = () => {
  const phoneNumber = "918799778497";
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <div className="whatsapp-icon-container">
        <FaWhatsapp className="whatsapp-icon" />
      </div>
      <span className="whatsapp-text">Whatsapp</span>
    </a>
  );
};

export default WhatsAppFloat;